import jQuery from "jquery";
window.$ = window.jQuery = jQuery; // Ensure both $ and jQuery are globally available

import Galleria from "galleria";
window.Galleria = Galleria;

(function($) {
    const getBooleanData = (element, key) => {
        const value = $(element).data(key);
        return value === true || value === "true";
    };

    const $galleries = $('.galleria');

    // Only load the theme on pages that actually render a gallery. The theme injects its CSS
    // dynamically and raises a full-page "Theme CSS could not load" banner if that CSS takes
    // longer than 5s; with no gallery instance debug mode stays on, so the banner showed on
    // every page (including the homepage) for visitors on slow or filtered networks.
    if (Galleria && $galleries.length > 0) {
        // Load the theme AFTER jQuery is globally set
        Galleria.loadTheme("/cmykhub-frontend/dist/galleria/galleria.classic.min.js");

        $galleries.each(function() {
            Galleria.run(this, {
                debug: false,
                showInfo: false,
                thumbnails: getBooleanData(this, 'thumbnails'),
                autoplay: getBooleanData(this, 'autoplay'),
                showCounter: getBooleanData(this, 'show-counter')
            });
        });
    }
})(jQuery);
